var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 3.20801C8.0396 3.20801 3.20801 8.0396 3.20801 13.9997C3.20801 19.9597 8.0396 24.7913 13.9997 24.7913C19.9597 24.7913 24.7913 19.9597 24.7913 13.9997C24.7913 8.0396 19.9597 3.20801 13.9997 3.20801ZM1.45801 13.9997C1.45801 7.0731 7.0731 1.45801 13.9997 1.45801C20.9262 1.45801 26.5413 7.0731 26.5413 13.9997C26.5413 20.9262 20.9262 26.5413 13.9997 26.5413C7.0731 26.5413 1.45801 20.9262 1.45801 13.9997Z",
    fill: "#FFFDF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5595 10.4399C11.2503 10.1307 10.749 10.1307 10.4399 10.4399C10.1307 10.749 10.1307 11.2503 10.4399 11.5595L12.8801 13.9997L10.4399 16.4399C10.1307 16.749 10.1307 17.2503 10.4399 17.5595C10.749 17.8686 11.2503 17.8686 11.5595 17.5595L13.9997 15.1193L16.4399 17.5595C16.749 17.8686 17.2503 17.8686 17.5595 17.5595C17.8686 17.2503 17.8686 16.749 17.5595 16.4399L15.1193 13.9997L17.5595 11.5595C17.8686 11.2503 17.8686 10.749 17.5595 10.4399C17.2503 10.1307 16.749 10.1307 16.4399 10.4399L13.9997 12.8801L11.5595 10.4399Z",
    fill: "#FFFDF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.be528d0cc91fa507c520bedcacdf5f2d.svg";
export { ForwardRef as ReactComponent };